import { MappingStatus, RuleApplyStatus } from '@types'

// Mapping Status Utilities
export const MAPPING_STATUS_LABELS = {
  [MappingStatus.OK]: 'Successfully Mapped',
  [MappingStatus.FAILED]: 'Mapping Failed',
  [MappingStatus.PENDING]: 'Mapping Pending',
} as const

export const MAPPING_STATUS_COLORS = {
  [MappingStatus.OK]: 'success',
  [MappingStatus.FAILED]: 'error',
  [MappingStatus.PENDING]: 'warning',
} as const

// Rule Apply Status Utilities
export const RULE_APPLY_STATUS_MESSAGES = {
  [RuleApplyStatus.SUCCESS]: 'All transactions processed successfully!',
  [RuleApplyStatus.FAILED]: 'Rule could not be applied to any transactions.',
  [RuleApplyStatus.PARTIAL]: 'Rule applied partially. Some transactions could not be processed.',
  [RuleApplyStatus.NOT_APPLIED]: 'No transactions matched the rule criteria or the rule is already applied. Please review your rule settings.',
} as const

export const RULE_APPLY_STATUS_NOTIFICATION_TYPES = {
  [RuleApplyStatus.SUCCESS]: 'success',
  [RuleApplyStatus.FAILED]: 'error',
  [RuleApplyStatus.PARTIAL]: 'warn',
  [RuleApplyStatus.NOT_APPLIED]: 'success',
} as const

// Rule Creation Status Messages
export const RULE_CREATION_STATUS_MESSAGES = {
  [RuleApplyStatus.SUCCESS]: 'Rule was created and applied successfully!',
  [RuleApplyStatus.FAILED]: 'Rule was created, but applying failed.',
  [RuleApplyStatus.PARTIAL]: 'Rule was created, but not all transactions were applied.',
  [RuleApplyStatus.NOT_APPLIED]: 'Rule created successfully.', // Default message when no transactions to apply
} as const
